import { isCommodity, type Commodity } from '@enmon/commons/lib/shared';
import { Checkbox } from 'antd';
import type { FC } from 'react';
import styled, { css } from 'styled-components';
import type { CheckboxGroupProps } from 'antd/lib/checkbox/Group';
import { getBoxGroupStyle } from '@/components/form/Radio/utils/getBoxGroupStyle';
import { useCommodityOptions } from '@/hooks/useCommodityOptions';

const StyledCheckBoxGroup = styled<FC<CheckboxGroupProps<Commodity> & { $compact: boolean }>>(Checkbox.Group)`
  ${({ $compact }) =>
    css`
      ${getBoxGroupStyle('checkbox', $compact)}
    `}
`;

interface CommoditiesCheckboxProps {
  allowed?: Commodity[];
  onlyConsumption?: boolean;
  value?: Commodity[];
  compact?: boolean;
  onChange?: (value: Commodity[]) => void;
}

export const CommoditiesCheckbox: FC<CommoditiesCheckboxProps> = props => {
  const { allowed = null, onlyConsumption = true, value, compact = true, onChange } = props;

  const options = useCommodityOptions(allowed, onlyConsumption, value, compact ? 'icon' : 'tile');

  const handleChange = (checkedValue: Commodity[]) => {
    onChange?.(checkedValue.filter(isCommodity));
  };

  return <StyledCheckBoxGroup $compact={compact} options={options} value={value} onChange={handleChange} />;
};
